<template lang="html">
  <!--<Navbar />-->
  <div class="content-i">
    <div class="content-box">
      <div class="row mt-sm-2">
        <div class="col-sm-12 col-md-6 col-lg-12">
          <div class="element-wrapper">
            <h6 class="element-header">{{ t('coreTypesText', 'coreTypesText') }}</h6>
            <b-card class="col-lg-12">
              <b-tabs>
                <b-tab>
                  <template v-slot:title>
                    {{ t('batchTypesText', 'batchTypesText') }}
                  </template>
                  <BatchTypes ref="batchTypeChild"></BatchTypes>
                </b-tab>
                <b-tab>
                  <template v-slot:title>
                    {{ t('documentTypesText', 'documentTypesText') }}
                  </template>
                  <DocumentTypes ref="documentTypeChild"></DocumentTypes>
                </b-tab>
                <b-tab>
                  <template v-slot:title>
                    {{ t('userDocumentTypesText', 'userDocumentTypesText') }}
                  </template>
                  <UserDocumentTypes ref="userDocTypeChild"></UserDocumentTypes>
                </b-tab>
              </b-tabs>
            </b-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import BatchTypes from '@/components/Core_Types/BatchTypes.vue'
import DocumentTypes from '@/components/Core_Types/DocumentTypes.vue'
import UserDocumentTypes from '@/components/Core_Types/UserDocumentTypes.vue'

export default {
  name: 'core_types',
  data() {
    return {
    }
  },
  provide() {
    return {
      openAddModal: this.openAddModal,
      resetAddModal: this.resetAddModal,
      openDeleteModal: this.openDeleteModal,
      resetDeleteModal: this.resetDeleteModal,
      openEditModal: this.openEditModal,
      resetEditModal: this.resetEditModal
    }
  },
  components: {
    BatchTypes,
    DocumentTypes,
    UserDocumentTypes
  },
  computed:{
    ...mapGetters(['allTemplateDetails', 'getUserDetails'])
  },
  methods: {
    openAddModal(title, button, componentName){
			this.$refs[componentName].modalOpen = true
			this.$refs[componentName].addModal.title = title
			this.$root.$emit('bv::show::modal', this.$refs[componentName].addModal.id, button)
    },
		openEditModal(title, name, button, componentName, className, batchId, internalName, docTypeId, userDocType, userDocId) {
			this.$refs[componentName].modalOpen = true
			this.$refs[componentName].editModal.title = title
			this.$refs[componentName].editModal.name = name
      this.$refs[componentName].editModal.userDocTypeId = userDocId
			this.$refs[componentName].editModal.class = className
      this.$refs[componentName].editModal.batchId = batchId
      this.$refs[componentName].editModal.internalName = internalName
      this.$refs[componentName].editModal.docTypeId = docTypeId
      this.$refs[componentName].selectedUserDocType = userDocType
			this.$root.$emit('bv::show::modal', this.$refs[componentName].editModal.id, button)
		},    
		openDeleteModal(name, title, button, componentName) {
      this.$refs[componentName].modalOpen = true
      this.$refs[componentName].deleteModal.name = name
      this.$refs[componentName].deleteModal.title = title
			this.$root.$emit('bv::show::modal', this.$refs[componentName].deleteModal.id, button)
		},    
    resetAddModal(componentName) {
      this.$refs[componentName].modalOpen = false
      this.$refs[componentName].addModal.title = ''
      if(componentName == 'userDocTypeChild'){
        this.$refs[componentName].newUserDocType = ''
      } else if(componentName == 'batchTypeChild') {
        this.$refs[componentName].newBatchType.name = ''
        this.$refs[componentName].newBatchType.class = ''
      } else {
			  this.$refs[componentName].newDocumentType.internalName = ''
			  this.$refs[componentName].newDocumentType.name = ''       
      }
    },
		resetEditModal(componentName) {
			this.$refs[componentName].modalOpen = false
			this.$refs[componentName].editModal.title = ''
			this.$refs[componentName].editModal.name = ''
      this.$refs[componentName].editModal.userDocTypeId = ''
      this.$refs[componentName].editModal.batchId = ''
			this.$refs[componentName].editModal.docTypeId = ''
			this.$refs[componentName].selectedUserDocType = null            
		},    
		resetDeleteModal(componentName) {
			this.$refs[componentName].modalOpen = false
			this.$refs[componentName].deleteModal.name = []
			this.$refs[componentName].deleteModal.title = ''
    }
  }
}
</script>

<style lang="css" scoped>

</style>